/*
* 시스템
* 클러스터 설정 VUEX store
*
* @since: 2021-09-08
* @author: 노우현 ( wh2295.noh )
*
*/

import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

const manager = () => {
  return {
    tamsServerIp: '',
    tamsServerPort: 0
  }
}

export const state = () => ({
  manager: manager(),
  clusters: [],
  maxRecord: 0,
  interfaces: [],
  isIpDisabled: false
})

export const mutations = {
  setIpDisabled (state, data) {
    state.isIpDisabled = data
  },
  initStore (state) {
    state.manager = manager()
    state.clusters = []
    state.maxRecord = 0
    state.interfaces = []
  },
  setManager (state, payload) {
    state.manager.tamsServerIp = payload.tams_server_ip
    state.manager.tamsServerPort = payload.tams_server_port
  },
  setClusters (state, payload) {
    state.clusters = payload
    if (state.clusters.length > 0) {
      for (let i = 1; i <= state.clusters.length; i++) {
        state.clusters[i - 1].priority = i
      }
    }
    state.maxRecord = state.clusters.length
  },
  setInterfaces (state, payload) {
    state.interfaces = payload
    for (let i = 0; i < state.interfaces.length; i++) {
      if (state.interfaces[i].hasOwnProperty('ipaddr')) {
        const splitedStrings = state.interfaces[i].ipaddr.split('/')
        state.interfaces[i].ipaddr = splitedStrings[0]
      }
    }
  },
  clearInterfaces (state) {
    state.interfaces = []
  }
}

export const actions = {
  // 매니저 정보 조회
  async getManager ({commit}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${apiPrefix}/cluster/manager`)
      if (res.code === 'ok') {
        commit('setManager', res.result)
      }
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  },
  // 클러스터 목록 조회
  async getClusters ({commit}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${apiPrefix}/cluster/clusters`)
      if (res.code === 'ok') {
        commit('setClusters', res.result)
      }
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  },
  async getInterfaces ({commit}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${apiPrefix}/interfaces`)
      if (res.code === 'ok') {
        commit('setInterfaces', res.result)
      }
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  }
}

export const getters = {
  getMaxPageIndex: (state) => {
    return state.clusters.length === 0 ? 1 : Math.ceil(state.clusters.length / 10)
  }
}

export const strict = false
